import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { HashRouter, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from './App.js';
import createStore from './store'
import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV !== 'test'){
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      })
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Logs
    enableLogs: true
  });
}

const history = createBrowserHistory();
const store = createStore();

ReactDOM.render(
  <Sentry.ErrorBoundary>
    <HashRouter history={history}>
      <Provider store={store}>
        <Switch>
          <Route path="/" name="Home" component={App} />
        </Switch>
      </Provider>
    </HashRouter>
  </Sentry.ErrorBoundary>
,
  document.getElementById('root') || document.createElement('div') // for testing purposes
);